<script>
	import Video from "./Video.svelte"
	import { onMount } from "svelte";

	let data = {};
	let currentFloor = {};

	onMount(async function() {
			const response = await fetch("assets/config.json");
			data = await response.json();
			console.log(await data)
			currentFloor = await data.Welcome
	});

	

	function changePage(link, toggle = true) {
		console.log("Changing to the " + link + " floor.")
		$: currentFloor = data[link];
		videoPlaying = false;
		if(toggle){navToggle()}
	}

	function showVideo(link) {
		console.log("Changing to the " + link + " video.")
		$: videoLink = link;
		videoPlaying = true;
	}

	function endVideo() {
		console.log("Ending video")
		videoPlaying = false;
	}

	let videoPlaying = false;
	let videoLink;
</script>

<div class="header">
	<!-- ///////////////////////////////////////////// -->
	<!-- EYEBROW -->
	<!-- ///////////////////////////////////////////// -->
	<div class="row vt-one-preHeader">
		<div class="vt-universal-access">
			<button onclick="accessToggle()" class="vt-access-toggle" aria-labelledby="vt_universal_access_label">
				<img alt="" src="https://www.assets.cms.vt.edu/images/accessibility_icon_white.svg"
					class="vt-access-toggle-icon vt-transparent-bg" focusable="false" aria-hidden="true" />
				<span class="sr-only">Universal Access Toggle</span>
			</button>
			<div role="tooltip" id="vt_universal_access_label" class="vt-universal-access-label">Universal Access</div>
			<div role="dialog" id="vt_access_dialog" aria-labelledby="access_dialog_label"
				aria-describedby="access_dialog_label" aria-modal="true" class="vt-access-dialog-wrapper" aria-hidden="true">
				<div class="vt-access-dialog">
					<button onclick="accessToggle()" class="vt-access-dialog-close" tabindex="-1"
						aria-label="Close Universal Access dialog">
						<span class="far fa-times" focusable="false" aria-hidden="true"></span>
						<span class="sr-only">Close Universal Access dialog</span>
					</button>
					<span id="vt_access_dialog_label" class="vt-access-dialog-label">Universal Access Options</span>
					<ul id="uaRender" class="vt-access-options">
					</ul>
				</div> <!-- end vt-access-dialog -->
			</div> <!-- end vt_access_dialog -->
		</div> <!-- end vt-universal-access -->
	</div> <!-- end vt-one-preHeader -->
	<!-- ///////////////////////////////////////////// -->
	<!-- END EYEBROW -->
	<!-- ///////////////////////////////////////////// -->



	<!-- ///////////////////////////////////////////// -->
	<!-- HEADER -->
	<!-- ///////////////////////////////////////////// -->
	<div class="row vt-one-headerRow">
		<header class="col header-col" role="banner">
			<div id="vt_logo">
				<a class="vt-logo-link" href="https://lib.vt.edu"><img alt="University Libraries at Virginia Tech"
						src="./assets/logo.png" /></a>
			</div>




			<!-- ///////////////////////////////////////////// -->
			<!-- MAIN NAVIGATION -->
			<!-- ///////////////////////////////////////////// -->
			<nav class="col" id="vt_nav" aria-label="Site Menu">
				<div class="linkWrapper">
					<button class="vt-nav-toggle" aria-controls="vt_main_nav" aria-expanded="false"
						onclick="javascript:navToggle();">
						<span class="vt-nav-toggleLabel">Menu</span>
						<span class="far fa-bars menu-open" aria-hidden="true" focusable="false" role="img"></span>
						<span class="far fa-times menu-close d-none" aria-hidden="true" focusable="false" role="img"></span>
					</button>
				</div>
				<div id="vt_offcanvas_nav" role="group" aria-label="Main Menu Drawer" aria-hidden="true" tabindex="-1">
					<ol id="vt_parent_org" class="vt-parent-org" aria-label="Parent Organization and Current Site">
						<li class="vt-currentSiteTitle">
							<a class="vt-currentSiteTitle-link" href="/" tabindex="-1">Library Tour</a>
						</li>
					</ol>

					<ul id="vt_main_nav" role="presentation" aria-label="Pages in Site">


						<!-- Single menu item example -->
						<li class="nav-item">
							<div class="link-wrapper"><a on:click="{() => changePage('Welcome')}" href="#" tabindex="-1">Welcome</a>
							</div>
						</li>
						<li class="nav-item">
							<div class="link-wrapper"><a on:click="{() => changePage('Fourth')}" href="#" tabindex="-1">4th Floor</a>
							</div>
						</li>
            <li class="nav-item">
							<div class="link-wrapper"><a on:click="{() => changePage('Third')}" href="#" tabindex="-1">3rd Floor</a>
							</div>
						</li>
						<li class="nav-item">
							<div class="link-wrapper"><a on:click="{() => changePage('Second')}" href="#" tabindex="-1">2nd Floor</a>
							</div>
						</li>
						<li class="nav-item">
							<div class="link-wrapper"><a on:click="{() => changePage('First')}" href="#" tabindex="-1">1st Floor</a>
							</div>
						</li>
						<li class="nav-item">
							<div class="link-wrapper"><a on:click="{() => changePage('Quiz')}" href="#" tabindex="-1">Quiz</a></div>
						</li>
            <li class="nav-item">
							<div class="link-wrapper"><a on:click="{() => changePage('Links')}" href="#" tabindex="-1">Links</a></div>
						</li>

					</ul>
				</div>
			</nav><!-- end vt_nav -->
			<!-- ///////////////////////////////////////////// -->
			<!-- END MAIN NAVIGATION -->
			<!-- ///////////////////////////////////////////// -->
	</div> <!-- end vt-one-headerRow -->
	<!-- ///////////////////////////////////////////// -->
	<!-- END HEADER -->
	<!-- ///////////////////////////////////////////// -->

</div> <!-- end header -->


<!-- ///////////////////////////////////////////// -->
<!-- BREADCRUMBS -->
<!-- ///////////////////////////////////////////// -->
<nav aria-label="Page Context" class="vt-page-path row">

	<div class="gateway">
		<ol id="vt_navtrail" class="long_title vt-breadcrumbs">
			<li class="vt-breadcrumbs-item">
				{#if videoPlaying}
				<a class="vt-breadcrumbs-link" on:click="{() => endVideo()}" href="#" tabindex="-1">
					&larr; Back to Tour<span class="breadcrumb-slash"> / </span>
				</a>
				{:else}
				<a class="vt-breadcrumbs-link" href="#" tabindex="-1">
					{#if currentFloor}{currentFloor.name}{/if}<span class="breadcrumb-slash"> / </span>
				</a>
				{/if}
			</li>
		</ol>
	</div>

</nav>
<!-- ///////////////////////////////////////////// -->
<!-- END BREADCRUMBS -->
<!-- ///////////////////////////////////////////// -->



<!-- ///////////////////////////////////////////// -->
<!-- MAIN CONTENT -->
<!-- ///////////////////////////////////////////// -->

{#if videoPlaying}
<Video link={videoLink} />
{:else}
<main style="min-height: 594px; padding: 1em;">
	<div class="row">
		<div class="col-12 col-lg-{currentFloor && currentFloor.map ? 5 : 12} vt-callToAction-message light">
			<div class="vt-vtcontainer">
				{#if currentFloor && currentFloor.text}
				<div class="vt-callToAction-message-heading">
					<div>
						<h2 class="vt-callToAction-primary">{currentFloor.heading}</h2>
					</div>
					<p class="vt-callToAction-message-description">{currentFloor.text}</p>
					{#if currentFloor.name === "Welcome"}
						<div class="vtctalink parbase section">
							<span class="d-flex justify-content-start">
								<a class="vt-ctaLink maroon gineso btn-shadow uppercase center" href="#"
									on:click="{() => {changePage('Fourth', false);}}" aria-label="Start Tour">
									Start Tour
								</a>
							</span>
						</div>
					{/if}
				</div>
				{/if}
				{#if currentFloor && currentFloor.stops}
				{#each currentFloor.stops as stop (stop.name)}
				<div class="vtctalink parbase section">
					<span class="d-flex justify-content-start">
						<a class="vt-ctaLink {stop.watched ? 'maroon outline' : 'light'} gineso btn-shadow uppercase w-100" href="#"
							on:click="{() => {showVideo(stop.video); stop.watched=true;}}" aria-label="{stop.name}">
							{stop.name}
						</a>
					</span>
				</div>
				{:else}
				<!-- this block renders when photos.length === 0 -->
				<p>loading...</p>
				{/each}
				<div class="vtctalink parbase section">
					<span class="d-flex justify-content-start">
						<a class="vt-ctaLink maroon gineso btn-shadow uppercase center" href="#"
							on:click="{() => {navToggle();}}" aria-label="Continue Tour">
							Continue Tour
						</a>
					</span>
				</div>
				{/if}
				{#if currentFloor && currentFloor.name === "Quiz"}
				<div class="vtctalink parbase section">
					<span class="d-flex justify-content-start">
						<a class="vt-ctaLink light gineso btn-shadow uppercase w-100" href="https://canvas.vt.edu/"
							aria-label="Take the Quiz">
							Take the Quiz
						</a>
					</span>
				</div>
				{/if}
			</div>
		</div>
		{#if currentFloor && currentFloor.map}
		<div class="col-12 col-lg-7 vt-callToAction-supplement">
			<div class="vt-image vt_large_img vt_adaptive_img caption ">
				<picture>
					<img src="./assets/{currentFloor.map}" alt="{currentFloor.name} Map">
				</picture>
			</div>
		</div>
		{/if}
	</div>
</main>
{/if}

<!-- ///////////////////////////////////////////// -->
<!-- END MAIN CONTENT -->
<!-- ///////////////////////////////////////////// -->

<style>
	picture>img {
		max-width: 100%;
		box-shadow: 0 0 30px rgba(229, 225, 230, .7);
	}

	.vt-vtcontainer {
		justify-content: space-evenly;
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.vt-callToAction-message-heading {
		margin: 0 2em;
	}

	.vt-callToAction-primary {
		text-align: center;
	}

	.vtctalink .vt-ctaLink.light {
		padding-left: 4rem;
		padding-right: 4rem;
	}
</style>